import { LowerCasePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { getFullPath } from '../../../lib/get-full-path';
import { StoryblokCdnPipe } from '../../../storyblok/pipes/storyblok-cdn.pipe';
import { StoryblokImage, StoryblokLink } from '../../../storyblok/storyblok-types';
import { ButtonDirective } from '../../directives/button.directive';
import { ContextMenuComponent } from '../context-menu/context-menu.component';
import { SvgComponent } from '../svg/svg.component';

interface HeaderButton {
  component: 'MenuItem';
  text: string;
  link: StoryblokLink;
  icon: StoryblokImage;
}

interface HeaderDropdownItem {
  component: 'MenuDropdown';
  text: string;
  buttons: HeaderButton[];
}

export type MenuItem = HeaderButton | HeaderDropdownItem;

@Component({
  selector: 'app-website-desktop-menu',
  templateUrl: './website-desktop-menu.component.html',
  styleUrls: ['./website-desktop-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonDirective,
    RouterLink,
    RouterLinkActive,
    ContextMenuComponent,
    NgClass,
    SvgComponent,
    LowerCasePipe,
    StoryblokCdnPipe,
  ],
})
export class WebsiteDesktopMenuComponent {
  private route = inject(ActivatedRoute);
  @Input() menuStructure: MenuItem[];

  isActive(item: HeaderDropdownItem) {
    const route = getFullPath(this.route.snapshot);
    route[0] = '/' + route[0];
    return item.buttons.some(item => {
      if (!item.link) return;
      return JSON.stringify(route) === JSON.stringify(item.link.cached_url || item.link.url);
    });
  }
}
